import { ContentContext, CountryContext, LocaleContext } from 'Components/hooks/context';
import React, { useContext } from 'react';

import AsideBox from 'Components/common/AsideBox';
import AtlasMetadataClient from '@reuters-graphics/graphics-atlas-client';
import Dateline from 'Components/common/Dateline';
import Globe from './Globe';
import SmartText from '@reuters-graphics/react-smart-text';
import Status from './Status';
import TopStats from './TopStats';
import classnames from 'classnames';
import { component } from './styles.module.scss';
import has from 'lodash/has';

const atlas = new AtlasMetadataClient();

const Headline = (props) => {
  const { globalStatistics, warning, caseCounts } = props;

  const locale = useContext(LocaleContext);
  const countrySlug = useContext(CountryContext);
  const content = useContext(ContentContext);

  const country = atlas.getCountry(countrySlug);

  const lastWeekTotal = caseCounts.slice(-7).reduce((a, d) => a + d.count, 0);
  // per 100K
  const lastWeekPerPop = has(country, 'dataProfile.population.d') ? Math.floor(lastWeekTotal / country.dataProfile.population.d * 100000) : null;

  return (
    <div className={classnames(component)}>
      <div className='section-spacer-internal' />
      <div className='clearfix'>
        <Globe location={countrySlug} />
        <div className='title-container'>
          <h1>{atlas.getCountry(countrySlug).translations[locale]}</h1>
          <Status globalStatistics={globalStatistics} />
          {(has(content, 'common.rate.ofPop') && lastWeekPerPop) && (
            <div className='rate'>
              <SmartText
                source={content.common.rate.ofPop}
                context={{ cases: lastWeekPerPop.toLocaleString(locale) }}
                wrap
              />
            </div>
          )}
          <Dateline />
          {(warning && warning[locale]) && (
            <AsideBox
              title={content.template.warning.title}
              source={warning[locale]}
              red
            />
          )}

          <TopStats
            globalStatistics={globalStatistics}
            caseCounts={caseCounts}
          />
        </div>
      </div>
    </div>
  );
};

export default Headline;
